/**
 * @preserve
 * Licenses of bundled dependencies can be found in dependencies-licenses.txt
 */
function hasRTLContext(t){return Boolean(t.closest('[dir="rtl"]'))}export{hasRTLContext as h};
//# sourceMappingURL=has-rtl-context-02cf81a3.js.map